import React from "react";
import LeftFilters from "./LeftFilters";
import PrimaryButton from "../../../../components/Button/Button";
import Chip from "@mui/material/Chip";
import { useSelector } from "react-redux";
import ComplianceYear from "../../../LeadCompliance/components/Header/ComplianceYear";
import RightFilters from "../../../LeadCompliance/components/Filters/RightFilters";
import MailerToSend from "../../../LeadCompliance/components/Header/Download/MailerToSend";
import MailerForReview from "../../../LeadCompliance/components/Header/Download/MailerForReview";
import { downloadll55PendingMailer } from "../../../../sevices/ll55Api";
import { isAdmin, isSelfService } from "../../../../utils/helpers";
import { downloadLl55AuditReport } from "../../../../sevices/ll55Api";

function Filters({  isFilterHide =false }) {
  const statusCount = useSelector((state) => state.ll55.count);
  return (
    <div className="tickets-filter  bg-white">
      <div
        className={`d-flex align-items-center justify-content-space-between ${
          !isFilterHide ? "filter-border" : ""
        } filter-paddings filter-bottom-paddings`}
      >
        <ComplianceYear name={"Compliance Year"} />
        <div className="d-flex">
          <RightFilters complianceType={"is_ll55"} auditReportApi={downloadLl55AuditReport} type="ll55"/>
          {(isAdmin() || isSelfService()) && (
            <>
             {isAdmin() && <MailerToSend
                btnTitle={"Print notices"}
                downloadCallback={downloadll55PendingMailer}
                pdfName={"ll55-report-mailer-to-send.pdf"}
                downloadPath={true}
              />}
              <MailerForReview
                btnTitle={"Mailers for Review"}
                downloadCallback={downloadll55PendingMailer}
                pdfName={"ll55-report-mailer-for-review.pdf"}
                downloadPath={true}
              />
            </>
          )}
        </div>
      </div>
      {!isFilterHide && (
        <div className="d-flex align-items-center justify-content-space-between filter-top-paddings">
          <LeftFilters />
          <PrimaryButton
            variant="contained"
            className={`capitalize`}
            disabled={true}
          >
            Returned Notices
            <Chip
              label={
                (statusCount?.completed ?? 0) + (statusCount?.in_process ?? 0)
              }
              size="small"
              color="success"
              sx={{ backgroundColor: "#11b50c66 !important" }}
              className="ml-1"
            />
          </PrimaryButton>
        </div>
      )}
    </div>
  );
}

export default Filters;
